/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Listings_TitleInputs */

const en_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Listings`)
};

const es_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis anuncios`)
};

const fr_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes annonces`)
};

const de_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Inserate`)
};

const ja_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイ出品`)
};

const zh_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的商品`)
};

const ar_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعلاناتي`)
};

const id_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Saya`)
};

const it_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I Miei Annunci`)
};

const ru_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мои объявления`)
};

const pt_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meus Anúncios`)
};

const ko_seller_listings_title = /** @type {(inputs: Seller_Listings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 상품`)
};

/**
* | output |
* | --- |
* | "My Listings" |
*
* @param {Seller_Listings_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_listings_title = /** @type {((inputs?: Seller_Listings_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Listings_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_listings_title(inputs)
	if (locale === "es") return es_seller_listings_title(inputs)
	if (locale === "fr") return fr_seller_listings_title(inputs)
	if (locale === "de") return de_seller_listings_title(inputs)
	if (locale === "ja") return ja_seller_listings_title(inputs)
	if (locale === "zh") return zh_seller_listings_title(inputs)
	if (locale === "ar") return ar_seller_listings_title(inputs)
	if (locale === "id") return id_seller_listings_title(inputs)
	if (locale === "it") return it_seller_listings_title(inputs)
	if (locale === "ru") return ru_seller_listings_title(inputs)
	if (locale === "pt") return pt_seller_listings_title(inputs)
	return ko_seller_listings_title(inputs)
});